import PropTypes from "prop-types";
import React, { useState } from "react";

/**
 * Returns index of item where key value has reached charLimit.
 *
 * @param {Object[]]} list
 * @param {Number} charLimit
 */
const getIndexAtCharLimit = (list, key, charLimit) => {
  let charCount = 0;
  return list.findIndex(item => {
    charCount += item[key].length;
    return charCount >= charLimit;
  });
};

const TextExpander = ({ list, charLimit }) => {
  const [expanded, setExpanded] = useState(false);

  const overLimit = list.map(item => item.text).join("").length >= charLimit;

  let displayList;
  if (expanded || !overLimit) {
    displayList = list;
  } else {
    const lastVisibleItem = getIndexAtCharLimit(list, "text", charLimit);
    displayList = list.slice(0, lastVisibleItem);
  }

  return (
    <div>
      {displayList.map((item, index) => (
        <span key={item.id} className="p-muted-text">
          {index ? `, ${item.text.toLowerCase()}` : item.text.toLowerCase()}
        </span>
      ))}
      {overLimit && (
        <div>
          {!expanded && (
            <button
              className="p-button--link"
              type="button"
              onClick={() => setExpanded(true)}
            >
              <small>View more&hellip;</small>
            </button>
          )}
          {expanded && (
            <button
              className="p-button--link"
              type="button"
              onClick={() => setExpanded(false)}
            >
              <small>View less&hellip;</small>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

TextExpander.defaultProps = {
  charLimit: 175
};

TextExpander.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    })
  ).isRequired,
  charLimit: PropTypes.number
};

export default TextExpander;
